// 后台「新手计划」页面文案
export default {
  vi: {
    aNewbieTitle: 'Chương trình khách mới',
    aNewbieSubtitle: 'Tự động theo ngày đăng ký, từ ngày 4 áp dụng dài hạn',
    aNewbieLoading: 'Đang tải...',
    aNewbieColDay: 'Ngày',
    aNewbieStatus: 'Trạng thái',
    aNewbieColNewUsers: 'Khách mới',
    aNewbieActions: 'Thao tác',
    aNewbieEmpty: 'Chưa có dữ liệu',
    aNewbieDay: 'Ngày {day}',
    aNewbieOn: 'Đang bật',
    aNewbieOff: 'Đang tắt',
    aNewbieTaskCount: 'Số nhiệm vụ trong ngày',
    aNewbieRewardRange: 'Hoa hồng mỗi nhiệm vụ',
    aNewbieRewardTotal: 'Tổng hoa hồng dự kiến',
    aNewbieLuckyPositions: 'Vị trí đơn may mắn',
    aNewbieLuckyAmounts: 'Số tiền khách phải ứng',
    aNewbieLuckyPayouts: 'Số tiền hoàn lại ngay',
    aNewbieTopupTarget: 'Bổ sung số dư tới',
    aNewbieWithdrawRange: 'Khoảng tiền rút tự duyệt',
    aNewbieAutoPayout: 'Tự động duyệt rút tiền',
    aNewbieRemark: 'Ghi chú',
    aNewbieEdit: 'Sửa',
    aNewbieSave: 'Lưu',
    aNewbieSaving: 'Đang lưu...',
    aNewbieCancel: 'Hủy',
    aNewbieSaved: 'Đã lưu',
    aNewbieEnabledLabel: 'Bật ngày này',
    aNewbieLuckyStats: 'Đơn may mắn đã phát',
    aNewbieLuckyPaid: 'Đã trả',
    aNewbieLuckyPending: 'Chưa trả',
    aNewbieLuckyNone: 'Chưa có đơn nào',
    aNewbieLuckyInReview: 'Đang duyệt',
    aNewbieLuckyReviewTitle: 'Đơn may mắn chờ duyệt',
    aNewbieLuckyReviewEmpty: 'Không có đơn nào chờ duyệt',
    aNewbieLuckyColUser: 'Khách hàng',
    aNewbieLuckyColAmount: 'Đã ứng',
    aNewbieLuckyColPayout: 'Hoàn lại',
    aNewbieLuckyColPaidAt: 'Thời điểm thanh toán',
    aNewbieLuckyApprove: 'Duyệt',
    aNewbieLuckyReject: 'Từ chối',
    aNewbieLuckyApproveConfirm: 'Duyệt đơn may mắn của {user}, hoàn {payout} vào số dư?',
    aNewbieLuckyRejectConfirm: 'Từ chối đơn may mắn của {user}, hoàn lại {amount} đã ứng?',
    aNewbieLuckyApproved: 'Đã duyệt',
    aNewbieLuckyRejected: 'Đã từ chối',
    aNewbieNewUsers: 'Người dùng mới ở ngày này',
    aNewbieUsers: '{count} người',
    aNewbieHintPositions: 'Cách nhau bằng dấu phẩy, ví dụ 20,40',
    aNewbieHintPayouts: 'Để trống = hoàn 110% số tiền ứng'
  },
  en: {
    aNewbieTitle: 'New user plan',
    aNewbieSubtitle: 'Applies automatically by signup date; day 4 runs long term',
    aNewbieLoading: 'Loading...',
    aNewbieColDay: 'Day',
    aNewbieStatus: 'Status',
    aNewbieColNewUsers: 'New users',
    aNewbieActions: 'Actions',
    aNewbieEmpty: 'No data',
    aNewbieDay: 'Day {day}',
    aNewbieOn: 'On',
    aNewbieOff: 'Off',
    aNewbieTaskCount: 'Tasks per day',
    aNewbieRewardRange: 'Reward per task',
    aNewbieRewardTotal: 'Expected daily total',
    aNewbieLuckyPositions: 'Lucky order positions',
    aNewbieLuckyAmounts: 'Amounts the user fronts',
    aNewbieLuckyPayouts: 'Instant payouts',
    aNewbieTopupTarget: 'Top balance up to',
    aNewbieWithdrawRange: 'Auto-approved withdrawal range',
    aNewbieAutoPayout: 'Auto-approve withdrawals',
    aNewbieRemark: 'Note',
    aNewbieEdit: 'Edit',
    aNewbieSave: 'Save',
    aNewbieSaving: 'Saving...',
    aNewbieCancel: 'Cancel',
    aNewbieSaved: 'Saved',
    aNewbieEnabledLabel: 'Enable this day',
    aNewbieLuckyStats: 'Lucky orders issued',
    aNewbieLuckyPaid: 'Paid',
    aNewbieLuckyPending: 'Unpaid',
    aNewbieLuckyNone: 'None yet',
    aNewbieLuckyInReview: 'In review',
    aNewbieLuckyReviewTitle: 'Lucky orders pending review',
    aNewbieLuckyReviewEmpty: 'No orders pending review',
    aNewbieLuckyColUser: 'Customer',
    aNewbieLuckyColAmount: 'Paid',
    aNewbieLuckyColPayout: 'Payout',
    aNewbieLuckyColPaidAt: 'Paid at',
    aNewbieLuckyApprove: 'Approve',
    aNewbieLuckyReject: 'Reject',
    aNewbieLuckyApproveConfirm: 'Approve {user}\'s lucky order and pay out {payout} to their balance?',
    aNewbieLuckyRejectConfirm: 'Reject {user}\'s lucky order and refund the {amount} they paid?',
    aNewbieLuckyApproved: 'Approved',
    aNewbieLuckyRejected: 'Rejected',
    aNewbieNewUsers: 'New users on this day',
    aNewbieUsers: '{count} users',
    aNewbieHintPositions: 'Comma separated, e.g. 20,40',
    aNewbieHintPayouts: 'Leave empty = pay back 110% of the fronted amount'
  },
  ko: {
    aNewbieTitle: '신규 플랜',
    aNewbieSubtitle: '가입일 기준 자동 적용, 4일차부터 장기 운영',
    aNewbieLoading: '불러오는 중...',
    aNewbieColDay: '일차',
    aNewbieStatus: '상태',
    aNewbieColNewUsers: '신규 회원',
    aNewbieActions: '관리',
    aNewbieEmpty: '데이터 없음',
    aNewbieDay: '{day}일차',
    aNewbieOn: '사용 중',
    aNewbieOff: '꺼짐',
    aNewbieTaskCount: '일일任務 수',
    aNewbieRewardRange: '任務당 보상',
    aNewbieRewardTotal: '일일 예상 총액',
    aNewbieLuckyPositions: '행운 주문 위치',
    aNewbieLuckyAmounts: '고객 선불 금액',
    aNewbieLuckyPayouts: '즉시 지급 금액',
    aNewbieTopupTarget: '잔액 보충 목표',
    aNewbieWithdrawRange: '자동 승인 출금 범위',
    aNewbieAutoPayout: '출금 자동 승인',
    aNewbieRemark: '비고',
    aNewbieEdit: '편집',
    aNewbieSave: '저장',
    aNewbieSaving: '저장 중...',
    aNewbieCancel: '취소',
    aNewbieSaved: '저장되었습니다',
    aNewbieEnabledLabel: '이 날짜 사용',
    aNewbieLuckyStats: '발행된 행운 주문',
    aNewbieLuckyPaid: '지급 완료',
    aNewbieLuckyPending: '미지급',
    aNewbieLuckyNone: '아직 없음',
    aNewbieLuckyInReview: '심사 중',
    aNewbieLuckyReviewTitle: '행운 주문 심사 대기',
    aNewbieLuckyReviewEmpty: '심사 대기 중인 주문이 없습니다',
    aNewbieLuckyColUser: '고객',
    aNewbieLuckyColAmount: '선결제',
    aNewbieLuckyColPayout: '환급',
    aNewbieLuckyColPaidAt: '결제 시간',
    aNewbieLuckyApprove: '승인',
    aNewbieLuckyReject: '반려',
    aNewbieLuckyApproveConfirm: '{user} 님의 행운 주문을 승인하고 {payout}을(를) 잔액으로 환급하시겠습니까?',
    aNewbieLuckyRejectConfirm: '{user} 님의 행운 주문을 반려하고 선결제 금액 {amount}을(를) 환불하시겠습니까?',
    aNewbieLuckyApproved: '승인되었습니다',
    aNewbieLuckyRejected: '반려되었습니다',
    aNewbieNewUsers: '이 날짜의 신규 회원',
    aNewbieUsers: '{count}명',
    aNewbieHintPositions: '쉼표 구분, 예 20,40',
    aNewbieHintPayouts: '비워 두면 선불 금액의 110% 지급'
  },
  ja: {
    aNewbieTitle: '新規ユーザープラン',
    aNewbieSubtitle: '登録日基準で自動適用。4日目は長期運用',
    aNewbieLoading: '読み込み中...',
    aNewbieColDay: '日数',
    aNewbieStatus: '状態',
    aNewbieColNewUsers: '新規ユーザー',
    aNewbieActions: '操作',
    aNewbieEmpty: 'データなし',
    aNewbieDay: '{day}日目',
    aNewbieOn: '有効',
    aNewbieOff: '無効',
    aNewbieTaskCount: '1日のタスク数',
    aNewbieRewardRange: '1タスクの報酬',
    aNewbieRewardTotal: '1日の想定合計',
    aNewbieLuckyPositions: 'ラッキー注文の位置',
    aNewbieLuckyAmounts: '顧客の立て替え金額',
    aNewbieLuckyPayouts: '即時返金額',
    aNewbieTopupTarget: '残高チャージ目標',
    aNewbieWithdrawRange: '自動承認の出金額',
    aNewbieAutoPayout: '出金を自動承認',
    aNewbieRemark: '備考',
    aNewbieEdit: '編集',
    aNewbieSave: '保存',
    aNewbieSaving: '保存中...',
    aNewbieCancel: 'キャンセル',
    aNewbieSaved: '保存しました',
    aNewbieEnabledLabel: 'この日を有効にする',
    aNewbieLuckyStats: '発行されたラッキー注文',
    aNewbieLuckyPaid: '支払済',
    aNewbieLuckyPending: '未支払',
    aNewbieLuckyNone: 'まだありません',
    aNewbieLuckyInReview: '審査中',
    aNewbieLuckyReviewTitle: 'ラッキー注文 審査待ち',
    aNewbieLuckyReviewEmpty: '審査待ちの注文はありません',
    aNewbieLuckyColUser: 'ユーザー',
    aNewbieLuckyColAmount: '立替金額',
    aNewbieLuckyColPayout: '返還金額',
    aNewbieLuckyColPaidAt: '支払日時',
    aNewbieLuckyApprove: '承認',
    aNewbieLuckyReject: '却下',
    aNewbieLuckyApproveConfirm: '{user} さんのラッキー注文を承認し、{payout} を残高に返還しますか？',
    aNewbieLuckyRejectConfirm: '{user} さんのラッキー注文を却下し、立替金 {amount} を返金しますか？',
    aNewbieLuckyApproved: '承認しました',
    aNewbieLuckyRejected: '却下しました',
    aNewbieNewUsers: 'この日の新規ユーザー',
    aNewbieUsers: '{count} 人',
    aNewbieHintPositions: 'カンマ区切り、例 20,40',
    aNewbieHintPayouts: '空欄の場合は立て替え額の110%を返金'
  },
  zh: {
    aNewbieTitle: '新手计划',
    aNewbieSubtitle: '按注册日期自动生效，第 4 天起长期执行',
    aNewbieLoading: '加载中...',
    aNewbieColDay: '天数',
    aNewbieStatus: '状态',
    aNewbieColNewUsers: '新用户',
    aNewbieActions: '操作',
    aNewbieEmpty: '暂无数据',
    aNewbieDay: '第 {day} 天',
    aNewbieOn: '已开启',
    aNewbieOff: '已关闭',
    aNewbieTaskCount: '当天单数',
    aNewbieRewardRange: '单笔佣金区间',
    aNewbieRewardTotal: '当天预计总额',
    aNewbieLuckyPositions: '幸运订单插入位置',
    aNewbieLuckyAmounts: '客户垫付金额',
    aNewbieLuckyPayouts: '立即返还金额',
    aNewbieTopupTarget: '达标补足到',
    aNewbieWithdrawRange: '自动放款提现区间',
    aNewbieAutoPayout: '提现自动放款',
    aNewbieRemark: '备注',
    aNewbieEdit: '编辑',
    aNewbieSave: '保存',
    aNewbieSaving: '保存中...',
    aNewbieCancel: '取消',
    aNewbieSaved: '已保存',
    aNewbieEnabledLabel: '开启这一天',
    aNewbieLuckyStats: '已发幸运订单',
    aNewbieLuckyPaid: '已支付',
    aNewbieLuckyPending: '待支付',
    aNewbieLuckyNone: '暂无',
    aNewbieLuckyInReview: '待审核',
    aNewbieLuckyReviewTitle: '幸运订单待审核',
    aNewbieLuckyReviewEmpty: '暂无待审核订单',
    aNewbieLuckyColUser: '用户',
    aNewbieLuckyColAmount: '已垫付',
    aNewbieLuckyColPayout: '返还金额',
    aNewbieLuckyColPaidAt: '支付时间',
    aNewbieLuckyApprove: '通过',
    aNewbieLuckyReject: '驳回',
    aNewbieLuckyApproveConfirm: '通过 {user} 的幸运订单，返还 {payout} 到余额？',
    aNewbieLuckyRejectConfirm: '驳回 {user} 的幸运订单，退还已垫付的 {amount}？',
    aNewbieLuckyApproved: '已通过',
    aNewbieLuckyRejected: '已驳回',
    aNewbieNewUsers: '处于这一天的新用户',
    aNewbieUsers: '{count} 人',
    aNewbieHintPositions: '用英文逗号分隔，例如 20,40',
    aNewbieHintPayouts: '留空则按垫付金额的 110% 返还'
  }
};
